import TableComponent from "../../../Table/Table";
import { Button, Form, Spinner } from 'react-bootstrap'
import React, { useEffect, useState } from "react";
import { useSearchParams } from 'react-router-dom'
import axios from 'axios';
import Select from 'react-select'
import { Input } from 'rsuite'
import toast, { Toaster } from 'react-hot-toast';
import { useSelector } from 'react-redux';

export default function DomainSettings() {
    const [searchParams] = useSearchParams();
    const AffiliateID = searchParams.get('id');
    const StoreUser = useSelector((state) => state.user);
    const [affiliateLinks, setAffiliateLinks] = useState({})
    const [loading, setLoading] = useState(false)
    const [bonus, setBonus] = useState({
        description: "",
        amount: ""
    })
    const [formLoading, setFormLoading] = useState(false);
    const [affiliate, setAffiliate] = useState({})
    const [affliate, setAffliate] = useState({});
    const [affliatePermission, setAffliatePermission] = useState(false)
    const getLinks = async () => {
        setLoading(true)
        const response = await axios.get(window.__CFG.API + "affiliates/GetAffiliateLinks/" + AffiliateID, {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("raff-token")
            }
        })
        setLoading(false);
        if (response.data.Error === null) {
            setLoading(false)
            setAffiliateLinks(response.data.Result)
        }
    }
    useEffect(() => {
        if (StoreUser != undefined) {
            setAffliate(StoreUser.User)
        }
    }, [affliate])
    useEffect(() => { setAffliatePermission(checkPermission(affliate, "aff_domain_api")) }, [affliate])
    const checkPermission = (user, permission) => {
        var Permissions = user.Permissions;
        if (Permissions && Permissions.length > 0) {
            const index = Permissions.findIndex(per => per === permission)
            if (index != -1) return true;
            else return false;
        }
        return true
    }
    const getAffiliateById = async () => {
        const response = await axios.get(window.__CFG.API + "affiliates/GetAffiliate/" + AffiliateID, {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("raff-token")
            }
        })
        if (response.data.Error === null) {
            setAffiliate(response.data.Result)
        }
    }
    const saveLinks = async () => {
        setFormLoading(true);

        const response = await axios.post(window.__CFG.API + "affiliates/SaveAffiliateLinks/" + AffiliateID, affiliateLinks, {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("raff-token")
            }
        })

        setFormLoading(false);

        if (response.data.Error === null) {
            toast.success("Saved Sucessufully", {
                duration: 4000
            });
            getLinks();
        }
    }

    useEffect(() => { getLinks(); getAffiliateById(); }, [])
    const optionsCurrency = [{ label: "USD", value: 1 }]
    const Textarea = React.forwardRef((props, ref) => <Input {...props} as="textarea" ref={ref} />);

    return (
        <>
            <div className="page-aff-wp">
                <div className="page-aff-ttl">
                    Domain Settings
                </div>
                <div className="page-aff">
                    <div className="page-aff-nm">
                        Affiliate: {affiliate?.Username}
                    </div>
                </div>
                {
                    !loading ? (
                        <div className="main-pg-aff">
                            <div className="main-pg-aff-form">
                                <div className="aff-form-lbl">
                                    Affiliate Short URI
                                </div>
                                <div className="main-pg-in">
                                    <Form.Control disabled={!affliatePermission} type='text' value={affiliateLinks.short} onChange={e => setAffiliateLinks({ ...affiliateLinks, short: e.target.value })} style={{ width: "100%", padding: 4, borderRadius: 3, borderColor: "rgba(0,0,0,0.2)" }} />
                                </div>
                            </div>
                            <div className="main-pg-aff-form">
                                <div className="aff-form-lbl">
                                    Affiliate Main URI
                                </div>
                                <div className="main-pg-in">
                                    <Form.Control type='text' disabled={!affliatePermission} value={affiliateLinks.main} onChange={e => setAffiliateLinks({ ...affiliateLinks, main: e.target.value })} style={{ width: "100%", padding: 4, borderRadius: 3, borderColor: "rgba(0,0,0,0.2)" }} />
                                </div>
                            </div>
                            <div className="main-pg-aff-form">
                                <div className="aff-form-lbl">
                                    Affiliate Referral URI
                                </div>
                                <div className="main-pg-in">
                                    <Form.Control type='text' disabled={!affliatePermission} value={affiliateLinks.ref} onChange={e => setAffiliateLinks({ ...affiliateLinks, ref: e.target.value })} style={{ width: "100%", padding: 4, borderRadius: 3, borderColor: "rgba(0,0,0,0.2)" }} />
                                </div>
                            </div>
                            <div className="main-pg-aff-form" style={{ paddingTop: 10 }}>
                                <Button disabled={!affliatePermission || formLoading} onClick={saveLinks} className="w-100 bg-warning border-0 rounded-0 btn-height text-black btn-com-grp "
                                >
                                    {
                                        formLoading ? (
                                            <Spinner size="sm" />
                                        ) : (
                                            <>Save Links</>
                                        )
                                    }
                                </Button>
                            </div>
                        </div>
                    ) : (
                        <></>
                    )
                }
            </div>
        </>
    )
}